import api from '@/api'
import errors from '@/api/errors'
import store from '@/store'

const baseUrlRef = process.env.REVIEW_API_BASE_URL_REF
const baseUrlReg = process.env.REVIEW_API_BASE_URL_REG

const createGetParams = (args) => {
  const p = {}
  // required
  p.sessionID = store.getters['commons/cookies'].encsid
  p.country = process.env.COUNTRY
  // non-required
  if (store.getters['commons/cookies'].mchat) {
    p.accessToken = store.getters['commons/cookies'].mchat
  }
  if (args.targetUser) {
    p.nickname = args.targetUser
  }
  return p
}

const createNicknameCheckParams = (nickname) => {
  const p = {
    sessionID: store.getters['commons/cookies'].encsid,
    nickname: nickname
  }
  if (store.getters['commons/cookies'].mchat) {
    p.accessToken = store.getters['commons/cookies'].mchat
  }
  return p
}

const createRegistParams = (args) => {
  const p = {
    accessToken: store.getters['commons/cookies'].mchat,
    sessionID: store.getters['commons/cookies'].encsid,
    nickname: args.nickname
  }
  return p
}

const onReceived = (respBody) => {
  if (respBody.resultCode !== 0) {
    console.error(`API error code ${respBody.resultCode}`)
    if (respBody.resultCode === 611) { // アクセストークンエラー
      throw new errors.AuthenticationError()
    }
    throw new Error('問題が発生したためその後の処理を継続することができませんでした。時間を置いて再度利用をお願いします。')
  }
  return Promise.resolve(respBody.data)
}

const onReceivedNicknameCheckResult = (respBody) => {
  if (respBody.resultCode !== 0 && respBody.resultCode !== 104 && respBody.resultCode !== 106) {
    console.error(`API error code ${respBody.resultCode}`)
    if (respBody.resultCode === 611) { // アクセストークンエラー
      throw new errors.AuthenticationError()
    }
    throw new Error('問題が発生したためその後の処理を継続することができませんでした。時間を置いて再度利用をお願いします。')
  }
  return Promise.resolve(respBody)
}

export default {
  // ユーザ登録状況取得
  getUser: (args) => {
    const params = createGetParams(args)
    return api.post(`${baseUrlRef}/getUserReviewCount`, params).then(onReceived)
  },
  checkUserNickname: (nickname) => {
    const params = createNicknameCheckParams(nickname)
    return api.post(`${baseUrlRef}/checkUserNickname`, params).then(onReceivedNicknameCheckResult)
  },
  registUserNickname: (nickname) => {
    const params = createRegistParams(nickname)
    return api.post(`${baseUrlReg}/registUserNickname`, params).then(onReceivedNicknameCheckResult)
  }
}



// WEBPACK FOOTER //
// ./src/api/users.js